module.exports = __webpack_public_path__ + "img/tilda.a1ffa7c4.svg";